import React, { useState, FormEvent, useEffect, useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation, Icon } from "@blueprintjs/core";
import { DateInput2 } from "@blueprintjs/datetime2";
import { format, parse, addDays} from "date-fns";
import { IconNames } from "@blueprintjs/icons";

import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'

import { McallRecInfo } from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;


interface MarginCallRpt2ViewProps {
    gsb: AxiosInstance,
    Mcall: McallRecInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


function MarginCallRpt2View({ gsb, Mcall = {} as McallRecInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: MarginCallRpt2ViewProps) {

    const { t, i18n } = useTranslation();    

    const [isDeletePress, setisDeletePress] = useState(false)


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    if (! ("d_acCode" in Mcall)) return null

    
    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row No-Print">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode">
                    <InputGroup readOnly value={Mcall.d_acCode} />
                </FormGroup>
                {/* <FormGroup className="Col-3-3" label="Client Name">
                    <div>
                    <div id="DispText">{Mcall.d_acName1}</div>
                    <div id="DispText">{Mcall.d_acName2}</div>
                    </div>
                </FormGroup> */}
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Call Date" labelFor="input_Tran_date">
                    <InputGroup readOnly value= {utils.dispDate(Mcall.d_Tran_date, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Call Amount (T+0)" labelFor="input_MgnCallAmt">
                    <InputGroup readOnly value={utils.formatNumber2(Mcall.d_MgnCallAmt0)} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Call Amount (T+2)" labelFor="input_MgnCallAmt">
                    <InputGroup readOnly value={utils.formatNumber2(Mcall.d_MgnCallAmt)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Settle Date" labelFor="input_MgnCallSettleDate">
                    <InputGroup readOnly value= {utils.dispDate(Mcall.d_MgnCallSettleDate, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Remark" labelFor="input_Remark">
                    <InputGroup readOnly value={Mcall.d_Remark} />
                </FormGroup>
            </div>
        </div>
    )
}



interface MarginCallRpt2EditProps {
    gsb: AxiosInstance,
    Mcall?: McallRecInfo,
    isNew?: boolean,
    onSave?: (Mcall: McallRecInfo) => void,
    onCancel?: () => void;
}

function MarginCallRpt2Edit({ gsb, Mcall = {} as McallRecInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: MarginCallRpt2EditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<McallRecInfo>()
    const { t, i18n } = useTranslation();    

    const [AcCodeValue, setAcCodeValue] = useState(Mcall.d_acCode)


    useEffect(() => {
        // Call reset to get the values of record McallRecInfo 
        if ("d_acCode" in Mcall) {
            reset(Mcall)
        }
    }, [Mcall, reset])

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        //register({ name: "d_Market" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    if (! isNew && ! ("d_acCode" in Mcall)) return null


    const onSubmit = (data: McallRecInfo) => {

        //console.log("MarginCallRpt2edit onsubmit data: ", data)

        data.d_acCode = AcCodeValue;
        if ( typeof(data.d_acCode) === "undefined" ) {
            data.d_acCode = ""
        }
        data.d_acCode = data.d_acCode.toUpperCase();



        (async () => {
            try {
                //console.log("call MarginCallRpt2edit data", data)
                //console.log("call MarginCallRpt2edit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "MarginCallRpt2", cAction: "MarginCallRpt2Validate", isNew: isNew})
                //console.log("MarginCallRpt2edit res.data.ok", res.data.ok)
                //console.log("MarginCallRpt2edit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

/*                        
                    setError("d_FeeCode", {
                        type: "manual",
                        message: "Dont Forget Your abc !"
                    }); 
                    console.log("MarginCallRpt2edit onsubmit errors: ", errors)
*/                    
                    //console.log("MarginCallRpt2edit onsubmit GsbErrors: ", GsbErrors)

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }


    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }





    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup disabled={! isNew} id="inputacCode" value={AcCodeValue} autoFocus={isNew} defaultValue="" placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s)) } inputRef={register({ required: true , maxLength: 8}) }  />
                    {errors.d_acCode && errors.d_acCode.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}
                    {errors.d_acCode && errors.d_acCode.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_acCode && errors.d_acCode.types && <span id="Err_msg">{errors.d_acCode.types.message}</span>}
                </FormGroup>
                {/* <FormGroup className="Col-3-3" label="Client Name" labelFor="inputAcName1">
                    <div>
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                    </div>
                </FormGroup> */}
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Call Date" labelFor="input_Tran_date">
                    <InputGroup disabled={! isNew} id="input_Tran_date" name="d_Tran_date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_Tran_date && errors.d_Tran_date.types && <span id="Err_msg">{errors.d_Tran_date.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Call Amount (T+0)" labelFor="input_MgnCallAmt">
                    <InputGroup readOnly value={utils.formatNumber2(Mcall.d_MgnCallAmt0)} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Call Amount (T+2)" labelFor="input_MgnCallAmt">
                    <InputGroup readOnly value={utils.formatNumber2(Mcall.d_MgnCallAmt)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Settle Date" labelFor="input_MgnCallSettleDate">
                    <InputGroup id="input_MgnCallSettleDate" name="d_MgnCallSettleDate" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_MgnCallSettleDate && errors.d_MgnCallSettleDate.types && <span id="Err_msg">{errors.d_MgnCallSettleDate.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Remark" labelFor="input_Remark">
                    <InputGroup id="input_Remark" name="d_Remark" defaultValue="" placeholder="Remark ..." inputRef={register({ maxLength: 60}) } />
                    {errors.d_Remark && errors.d_Remark.type === "maxLength" && <span id="Err_msg">Max length is 60</span>}
                    {errors.d_Remark && errors.d_Remark.types && <span id="Err_msg">{errors.d_Remark.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface MarginCallRpt2MainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function MarginCallRpt2Main({ gsb }: MarginCallRpt2MainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { McallNo: defaultSearchValue = "" }: { McallNo: string } = useParams()

    const [data, setData] = useState([] as McallRecInfo[])

    const [searchKey, setSearchKey] = useState("McallNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchMcallFacCode, setsearchMcallFacCode] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentMcall, setCurrentMcall] = useState({} as McallRecInfo)
    const [BlankMcall, setBlankMcall] = useState({} as McallRecInfo)
    const [CurrentLog, setCurrentLog] = useState({} as McallRecInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    BlankMcall.d_acCode = ""
    BlankMcall.d_MgnCallAmt = 0
    BlankMcall.d_MgnCallAmt0 = 0
    BlankMcall.d_Remark = ""


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("MarginCallRpt2Main disp user_key: ", res.data.Flag.user_key)
                //console.log("MarginCallRpt2Main disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("MarginCallRpt2Main disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("MarginCallRpt2Main disp GsbFlag: ", GsbFlag)
                //console.log("MarginCallRpt2Main disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("MarginCallRpt2Main disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("MarginCallRpt2Main disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("MarginCallRpt2Main disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("MarginCallRpt2Main disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    const PrevRecProcess = async (Mcall: McallRecInfo) => {
        try {
            //console.log("call PrevRecProcess", Mcall)
            const res = await gsb.post('/Master', {sb_data: Mcall, cPgmId: "MarginCallRpt2", cAction: "PrevRec"})
            //console.log("PrevRecProcess show 1: ", Mcall.d_McallNo)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode+data[i].d_Tran_date === res.data.data.d_acCode+res.data.data.d_Tran_date) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentMcall(res.data.data)
            //console.log("PrevRecProcess show 2: ", Mcall.d_McallNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", Mcall.d_McallNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (Mcall: McallRecInfo) => {
        try {
            //console.log("call DeleteProcess", Mcall)
            const res = await gsb.post('/Master', {sb_data: Mcall, cPgmId: "MarginCallRpt2", cAction: "DelRec"})
            if (res.data.ok) {
                showSuccess("Account No. " + Mcall.d_acCode +", "+ Mcall.d_Tran_date + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_acCode+data[i].d_Tran_date === res.data.data.d_acCode+res.data.data.d_Tran_date) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
                setCurrentMcall(res.data.data)
                setCurrentMode("show")
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (Mcall: McallRecInfo) => {
        try {
            //console.log("call NextRecProcess", Mcall)
            const res = await gsb.post('/Master', {sb_data: Mcall, cPgmId: "MarginCallRpt2", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode+data[i].d_Tran_date === res.data.data.d_acCode+res.data.data.d_Tran_date) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentMcall(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (Mcall: McallRecInfo) => {
        try {
            //console.log("call newOnSave", Mcall)
            const res = await gsb.post('/Master', {sb_data: Mcall, cPgmId: "MarginCallRpt2", cAction: "AddRec"})
            showSuccess("Account No. " + Mcall.d_acCode +", "+ Mcall.d_Tran_date + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode+data[i].d_Tran_date === res.data.data.d_acCode+res.data.data.d_Tran_date) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentMcall(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (Mcall: McallRecInfo) => {
        try {
            //console.log("call editOnSave", Mcall)
            //console.log("Mcall.d_CcassMcall: ", Mcall.d_CcassMcall)
            const res = await gsb.post('/Master', {sb_data: Mcall, cPgmId: "MarginCallRpt2", cAction: "UpdateRec"})
            showSuccess("Account No. " + Mcall.d_acCode +", "+ Mcall.d_Tran_date + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode+data[i].d_Tran_date === res.data.data.d_acCode+res.data.data.d_Tran_date) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    //setCurrentMcall(Mcall)
                    break
                }
            }
            //console.log("editOnSave Mcall", Mcall)
            //console.log("editOnSave res.data.data", res.data.data)
            setCurrentMcall(res.data.data)
            setCurrentMode("show")
            //setisShowAlert1(true)
            //setShowAlert1Msg("Account No. " +ac.d_acCode + " record saved")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        // get MarginCallRpt2 list if McallNo have value
        try {
            //console.log("MarginCallRpt2Main onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            McallFacCode: searchMcallFacCode,
                        }, 
                    },
                    cPgmId: "MarginCallRpt2",
                    cAction: "ListRec",
                });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentMcall(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_acCode: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "MarginCallRpt2",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentMcall(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    // get one MarginCallRpt2 record if McallNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("MarginCallRpt2Main useEffect length > 0  called", data)
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "acCode",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "MarginCallRpt2",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentMcall(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                McallFacCode: searchMcallFacCode,
                            }, 
                        },
                        cPgmId: "MarginCallRpt2",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentMcall(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <MarginCallRpt2View gsb={gsb} Mcall={currentMcall} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentMcall)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentMcall)} onNextRec={() => NextRecProcess(currentMcall)} ></MarginCallRpt2View>
    switch (currentMode) {
        //case "PrevRec":
        // ?? will call 2 times ??
        //    console.log("currentMode = PrevRec")
        //    PrevRecProcess(currentMcall)
        //    break
        case "new":
            //console.log("currentMode = new")
            detail = <MarginCallRpt2Edit gsb={gsb} Mcall={BlankMcall} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></MarginCallRpt2Edit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <MarginCallRpt2Edit gsb={gsb} Mcall={currentMcall} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></MarginCallRpt2Edit>
            break
        //case "delete":
        //    console.log("currentMode = delete")
        //    DeleteProcess(currentMcall)
        //    break
    }


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={true} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Account No.</th>
                <th className="TCol-CallDate">Call Date</th>
                <th className="TCol-Amount">Call Amount (T+0)</th>
                <th className="TCol-Amount">Call Amount (T+2)</th>
                <th className="TCol-SettleDate">Settle Date</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((Mcall, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-ACCode" onClick={() => { setCurrentMcall(Mcall) ; MoblieDev && setSelectedTabId("detail") }}>{Mcall.d_acCode}</td>
                        <td className="TCol-CallDate" onClick={() => { setCurrentMcall(Mcall) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(Mcall.d_Tran_date, GsbFlag.dateFormat)}</td>
                        <td className="TCol-Amount" onClick={() => { setCurrentMcall(Mcall) }}>{utils.formatNumber2(Mcall.d_MgnCallAmt0)}</td>
                        <td className="TCol-Amount" onClick={() => { setCurrentMcall(Mcall) }}>{utils.formatNumber2(Mcall.d_MgnCallAmt)}</td>
                        <td className="TCol-SettleDate" onClick={() => { setCurrentMcall(Mcall) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(Mcall.d_MgnCallSettleDate, GsbFlag.dateFormat)}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div> 
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    {/* define search key */}
                    <H3><div style={{justifyContent: 'flex-end'}}>72M Record Settle Margin Call Entry</div></H3>
                    <div className="Row">
                        <FormGroup className="Col-1-5" label="Search for " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="acCode">Account No.</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "McallNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "McallNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Account No." labelFor="searchMcallFacCode">
                                <InputGroup id="searchMcallFacCode" value={searchMcallFacCode} onChange={utils.handleStringChange(s => setsearchMcallFacCode(s))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
            </form>
        </>
    );
}

export default MarginCallRpt2Main